import 'flag-icon-css/css/flag-icon.css'


//////////////////
// WEBPACK FOOTER
// ./~/vue-flag-icon/vendors/index.js
// module id = 754
// module chunks = 30